<div class="layout-row layout-align-start-center full-height">
  <bringoz-icon *ngIf="!loading" [iconName]="'location-pin-outline'" class="margin-right-5 padding-0"></bringoz-icon>

  <div *ngIf="!loading">
    <span class="br-body-1 font-weight-400 text-ellipsis">{{place || '---'}}</span>
  </div>
</div>
